<template>
  <span>
    <v-select v-if="!readonly"
      class="d-inline-block select-field-no-child-input mx-2" required dense hide-details
      append-icon="" text="text" value="value" height="14px" style="min-width: 80px;"
      v-model="inequality"
      :items="inequalities"
      @change="onQueryChange"/>
    <span v-else>{{inequalities.find(i => i.value === inequality).text}} </span>

    <span v-if="inequality === 'between' || inequality === 'gte'">
      <v-text-field v-if="!readonly"
        class="d-inline-block mx-2" required dense hide-details
        height="14px" style="width: 40px;"
        v-model="gte"
        type="number" min="1"
        @change="onQueryChange"
        @mouseup="onQueryChange"
      />
      <span v-else>{{ gte }} </span>
    </span>

    <span v-if="inequality === 'between'">and </span>

    <span v-if="inequality === 'between' || inequality === 'lt'">
      <v-text-field v-if="!readonly"
        class="d-inline-block mx-2" required dense hide-details
        height="14px" style="width: 40px;"
        v-model="lt"
        type="number" min="1"
        @change="onQueryChange"
        @mouseup="onQueryChange"
      />
      <span v-else>{{ lt }} </span>
    </span>

    <span v-if="inequality">minutes</span>

    every
    <v-text-field v-if="!readonly"
      class="d-inline-block mx-2" required dense hide-details
      height="14px" style="width: 40px;"
      v-model="period"
      type="number" min="1"
      @change="onQueryChange"
      @mouseup="onQueryChange"
    />
    <span v-else>{{ period }} </span>
    day<span v-if="period && period > 1">s</span>
  </span>
</template>

<script>
export default {
  name: "TimeSpentListening",
  props: {
    onQueryChange: {
      type: Function,
      required: true,
    },
    initialConfig: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      gte: null,
      lt: null,
      period: null,
      inequality: null,
      inequalities: [
        {text: "...", value: null},
        {text: "for between", value: "between"},
        {text: "for more than", value: "gte"},
        {text: "for less than", value: "lt"},
      ]
    }
  },
  methods: {
    onChangeInitialConfig() {
      this.gte = this.initialConfig.gte;
      if (this.gte) this.gte = this.gte / 60;
      this.lt = this.initialConfig.lt;
      if (this.lt) this.lt = this.lt / 60;
      this.period = this.initialConfig.period;

      if (this.gte) {
        if (this.lt) {
          this.inequality = "between";
        } else {
          this.inequality = "gte";
        }
      } else {
        if (this.lt) {
          this.inequality = "lt";
        } else {
          this.inequality = null;
        }
      }
    },
    getQuery() {
      const optionalFields = {};
      if (this.inequality === "between" || this.inequality === "gte") optionalFields.gte = this.gte * 60;
      if (this.inequality === "between" || this.inequality === "lt") optionalFields.lt = this.lt * 60;

      return {
        period: parseInt(this.period),
        ...optionalFields
      };
    },
  },
  watch: {
    initialConfig: {
      handler() {
        this.onChangeInitialConfig()
      },
      immediate: true,
    },
    gte(value) {
      if (!value) return;
      const intVal = parseInt(value);

      if (this.lt) {
        const intLt = parseInt(this.lt);
        if (intVal >= intLt) this.lt = intVal + 1;
      } else {
        this.lt = intVal + 1;
      }
    },
    lt(value) {
      if (!value) return;
      const intVal = parseInt(value);

      if (this.gte) {
        const intGte = parseInt(this.gte);
        if (intVal <= intGte) this.gte = intVal - 1;
      } else {
        this.gte = intVal - 1;
      }
    },
  }
}
</script>

<style scoped>

</style>